import { Modal } from 'components'
import { Dispatch, SetStateAction } from 'react'
import { useParams } from 'react-router-dom'

import * as S from './styles'
import ModalTrackingOV from './ModalTrackingOV'
import ModalTrackingOrder from './ModalTrackingOrder'

export interface PropsModal {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const ModalTracking = ({ open, setOpen }: PropsModal) => {
  const { ovNumber, orderNumber } = useParams()

  const isOrder = !!orderNumber
  const title = isOrder ? `pedido: #${orderNumber}` : `OV: #${ovNumber}`
  const subTitle = isOrder ? 'neste pedido' : 'nesta Ordem de Venda'

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title={`Tracking ${title}`}
      closeAction={handleClose}
      showAction={false}
    >
      <S.Content>
        <S.DescriptionWrapper>
          {`Acompanhe aqui todas as atualizações realizadas ${subTitle}.`}
        </S.DescriptionWrapper>

        {isOrder && open ? <ModalTrackingOrder /> : <ModalTrackingOV />}
      </S.Content>
    </Modal>
  )
}

export default ModalTracking
